module.exports = __webpack_public_path__ + "static/media/trs.2f78456a.svg";